import { render } from "./ChatRoomContent.vue?vue&type=template&id=0d9a7de1&scoped=true&ts=true"
import script from "./ChatRoomContent.vue?vue&type=script&lang=ts"
export * from "./ChatRoomContent.vue?vue&type=script&lang=ts"

import "./ChatRoomContent.vue?vue&type=style&index=0&id=0d9a7de1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9a7de1"]])

export default __exports__